/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Hold_Notes_PlaceholderInputs */

const en_inventory_hold_notes_placeholder = /** @type {(inputs: Inventory_Hold_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Customer called, holding for phone order`)
};

const es_inventory_hold_notes_placeholder = /** @type {(inputs: Inventory_Hold_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. El cliente llamo, apartado para pedido telefonico`)
};

/**
* | output |
* | --- |
* | "e.g., Customer called, holding for phone order" |
*
* @param {Inventory_Hold_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_hold_notes_placeholder = /** @type {((inputs?: Inventory_Hold_Notes_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Hold_Notes_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_hold_notes_placeholder(inputs)
	return es_inventory_hold_notes_placeholder(inputs)
});